export default __webpack_public_path__ + "static/media/common_ic_running.11630aad.png";